import React, { forwardRef, useEffect, useImperativeHandle } from 'react';
import { PlateFormat } from '~/dataModels/PlateFormat/PlateFormat';
import {
  Accordion,
  AccordionContent,
  AccordionTitle,
  Divider,
  Grid,
  Icon,
} from 'semantic-ui-react';
import {
  CombinationPricingOptionsContainer,
  CombinationPricingOptionsHeading,
  CombinationPricingOptionContainer,
  CombinationPricingOptionsImage,
  CombinationPricingOptionsPrice,
  CombinationPricingOptionsDescription,
  SelectedCombinationPricingOptionContainer,
  CombinationPricingOptionsExampleText,
  CombinationPricingOptionsPriceContainer,
  CombinationPricingDisclaimer,
  CombinationPricingOptionsOuterWrapper,
  LeftColumn,
} from './CombinationPricingOptions.styles';
import { H6 } from '@styles/Global.styles';
import theme from '@styles/theme';
import {
  getPlateFormatExampleCombinations,
  getPlateFormat,
} from '@utils/Helpers';
import { AfterpayMessage } from '@utils/Afterpay';
import { CombinationPaymentList } from './CombinationPaymentList';
import { useFetcher } from '@remix-run/react';
// import { getEmptyCheckout } from '~/stateManagement/localStorage/checkout';
// import { Checkout } from '~/dataModels/Checkout/Checkout';

interface CombinationPricingOptionsProps {
  combinationFormats: PlateFormat[];
  isDealer: boolean | undefined;
}

export interface CombinationPricingOptionsRef {
  selectCombinationFormat: (combination: string) => void;
  clearSelectCombinationFormat: () => void;
}

const CombinationPricingOptions = forwardRef<
  CombinationPricingOptionsRef,
  CombinationPricingOptionsProps
>((props: CombinationPricingOptionsProps, ref) => {
  const fetcher = useFetcher();
  const [selectedCombinationFormatId, setSelectedCombinationFormatId] =
    React.useState<number | undefined>(undefined);
  const [activeIndex, setActiveIndex] = React.useState(-1);
  //   const [checkout, setCheckout] = React.useState(getEmptyCheckout());

  //   useEffect(() => {
  //     fetcher.load('/api/checkout-data');
  //   }, []);

  //   useEffect(() => {
  //     if (fetcher.data) {
  //       setCheckout(fetcher.data as Checkout);
  //     }
  //   }, [fetcher.data]);

  useImperativeHandle(ref, () => ({
    selectCombinationFormat: (combination: string) => {
      const plateFormatName = getPlateFormat(combination);

      props.combinationFormats.forEach((plateFormat, index) => {
        if (
          plateFormatName.includes(
            plateFormat.formatType.slice(
              0,
              plateFormat.formatType.indexOf(' '),
            ),
          )
        ) {
          setSelectedCombinationFormatId(index);
        }
      });
    },
    clearSelectCombinationFormat: () => {
      setSelectedCombinationFormatId(undefined);
    },
  }));

  const handleClick = (e: any, titleProps: any) => {
    const { index } = titleProps;
    const newIndex = activeIndex === index ? -1 : index;

    setActiveIndex(newIndex);
  };

  return (
    <CombinationPricingOptionsOuterWrapper>
      <div className="hidden md:block">
        <CombinationPricingOptionsContainer>
          <CombinationPricingOptionsHeading>
            {selectedCombinationFormatId === undefined
              ? 'Plate Pricing Options'
              : 'Plate Pricing Options'}
          </CombinationPricingOptionsHeading>
          {selectedCombinationFormatId !== undefined && (
            <CombinationPricingOptionContainer>
              <CombinationPricingOptionsDescription>
                Your combination is a:
              </CombinationPricingOptionsDescription>
              <SelectedCombinationPricingOptionContainer>
                <Grid>
                  <Grid.Row>
                    <Grid.Column
                      mobile={16}
                      tablet={16}
                      computer={7}
                      largeScreen={7}
                      widescreen={7}
                    >
                      <H6>
                        {
                          props.combinationFormats[selectedCombinationFormatId]
                            .name
                        }
                      </H6>
                    </Grid.Column>
                    <CombinationPricingOptionsPriceContainer
                      mobile={16}
                      tablet={16}
                      computer={16}
                      largeScreen={9}
                      widescreen={9}
                    >
                      <CombinationPricingOptionsPrice
                        color={theme.brand.colors.green}
                      >
                        <label>From</label>
                        <span>
                          $
                          {
                            props.combinationFormats[
                              selectedCombinationFormatId
                            ].basePrice
                          }
                        </span>
                      </CombinationPricingOptionsPrice>
                    </CombinationPricingOptionsPriceContainer>
                    {props.combinationFormats[selectedCombinationFormatId]
                      .basePrice <= 2000 &&
                      !props.isDealer && (
                        <Grid.Column width={16}>
                          <CombinationPaymentList
                            basePrice={
                              props.combinationFormats[
                                selectedCombinationFormatId
                              ].basePrice
                            }
                          />
                        </Grid.Column>
                      )}

                    <Grid.Column width={16}>
                      <CombinationPricingOptionsDescription>
                        {
                          props.combinationFormats[selectedCombinationFormatId]
                            .description
                        }
                      </CombinationPricingOptionsDescription>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </SelectedCombinationPricingOptionContainer>
            </CombinationPricingOptionContainer>
          )}
          {props.combinationFormats.map((combinationFormat, index) => {
            if (index >= 3) {
              return;
            }
            const laybyFromPrice = combinationFormat.basePrice / 12;
            return (
              selectedCombinationFormatId !== index && (
                <CombinationPricingOptionContainer key={index}>
                  {/* <CombinationPricingOptionsDescription>
                                        <span className="other-description">
                                        Other available combination formats:
                                        </span>
                                    </CombinationPricingOptionsDescription> */}
                  <Grid columns={2}>
                    <Grid.Row>
                      <Grid.Column width={8}>
                        <H6>{combinationFormat.name}</H6>
                      </Grid.Column>
                      <CombinationPricingOptionsPriceContainer width={8}>
                        <CombinationPricingOptionsPrice
                          color={theme.brand.colors.green}
                        >
                          <label>From</label>
                          <span>${combinationFormat.basePrice}</span>
                        </CombinationPricingOptionsPrice>
                      </CombinationPricingOptionsPriceContainer>

                      {combinationFormat.basePrice <= 2000 &&
                        !props.isDealer && (
                          <Grid.Column width={16}>
                            <CombinationPaymentList
                              basePrice={combinationFormat.basePrice}
                            />
                          </Grid.Column>
                        )}
                      <Grid.Column width={16}>
                        <CombinationPricingOptionsDescription>
                          {combinationFormat.description}
                        </CombinationPricingOptionsDescription>
                      </Grid.Column>
                      {selectedCombinationFormatId === undefined && (
                        <Grid.Column width={16}>
                          <CombinationPricingOptionsExampleText>
                            Examples:
                          </CombinationPricingOptionsExampleText>
                          <div>
                            {getPlateFormatExampleCombinations(
                              combinationFormat.name,
                            ).map((exampleCombination, index) => {
                              return (
                                <CombinationPricingOptionsImage key={index}>
                                  <span>{exampleCombination}</span>
                                </CombinationPricingOptionsImage>
                              );
                            })}
                          </div>
                        </Grid.Column>
                      )}
                    </Grid.Row>
                  </Grid>
                </CombinationPricingOptionContainer>
              )
            );
          })}          
        </CombinationPricingOptionsContainer>
      </div>
      <div className="block md:hidden">
        <CombinationPricingOptionsHeading>
          {selectedCombinationFormatId === undefined ? (
            'Plate Pricing Options'
          ) : (
            <Grid columns={2}>
              <LeftColumn width={8}>
                <H6>
                  {props.combinationFormats[selectedCombinationFormatId].name}
                </H6>
              </LeftColumn>
              <CombinationPricingOptionsPriceContainer width={8}>
                <CombinationPricingOptionsPrice
                  color={theme.brand.colors.green}
                >
                  <label color="#eee">From</label>
                  <span>
                    $
                    {
                      props.combinationFormats[selectedCombinationFormatId]
                        .basePrice
                    }
                  </span>
                </CombinationPricingOptionsPrice>
              </CombinationPricingOptionsPriceContainer>
            </Grid>
          )}
        </CombinationPricingOptionsHeading>
        <Accordion className="outer-wrapper">
          <AccordionTitle
            className="accordion-title"
            active={activeIndex === 0}
            index={0}
            onClick={handleClick}
          >
            View format prices{' '}
            {activeIndex === 0 ? (
              <Icon name="chevron up" />
            ) : (
              <Icon name="chevron down" />
            )}
          </AccordionTitle>
          <AccordionContent
            active={activeIndex === 0}
            className="accordion-content"
          >
            {selectedCombinationFormatId !== undefined && (
              <CombinationPricingOptionContainer>
                <SelectedCombinationPricingOptionContainer>
                  <Grid>
                    <Grid.Row>
                      <Grid.Column width={8}>
                        <H6>
                          {
                            props.combinationFormats[
                              selectedCombinationFormatId
                            ].name
                          }
                        </H6>
                      </Grid.Column>
                      <CombinationPricingOptionsPriceContainer width={8}>
                        <CombinationPricingOptionsPrice
                          color={theme.brand.colors.green}
                        >
                          <label>From</label>
                          <span>
                            $
                            {
                              props.combinationFormats[
                                selectedCombinationFormatId
                              ].basePrice
                            }
                          </span>
                        </CombinationPricingOptionsPrice>
                      </CombinationPricingOptionsPriceContainer>
                      {props.combinationFormats[selectedCombinationFormatId]
                        .basePrice <= 2000 &&
                        !props.isDealer && (
                          <Grid.Column width={16}>
                            <CombinationPaymentList
                              basePrice={
                                props.combinationFormats[
                                  selectedCombinationFormatId
                                ].basePrice
                              }
                            />
                          </Grid.Column>
                        )}

                      <Grid.Column width={16}>
                        <CombinationPricingOptionsDescription>
                          {
                            props.combinationFormats[
                              selectedCombinationFormatId
                            ].description
                          }
                        </CombinationPricingOptionsDescription>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </SelectedCombinationPricingOptionContainer>
              </CombinationPricingOptionContainer>
            )}
            {props.combinationFormats.map((combinationFormat, index) => {
              if (index >= 3) {
                return;
              }
              const laybyFromPrice = combinationFormat.basePrice / 12;
              return (
                selectedCombinationFormatId !== index && (
                  <CombinationPricingOptionContainer key={index}>
                    {/* <CombinationPricingOptionsDescription>
                                            <span className="other-description">
                                            Other available combination formats:
                                            </span>
                                        </CombinationPricingOptionsDescription> */}
                    <Grid>
                      <Grid.Row>
                        <Grid.Column width={8}>
                          <H6>{combinationFormat.name}</H6>
                        </Grid.Column>
                        <CombinationPricingOptionsPriceContainer width={8}>
                          <CombinationPricingOptionsPrice
                            color={theme.brand.colors.green}
                          >
                            <label>From</label>
                            <span>${combinationFormat.basePrice}</span>
                          </CombinationPricingOptionsPrice>
                        </CombinationPricingOptionsPriceContainer>
                        {combinationFormat.basePrice <= 2000 &&
                          !props.isDealer && (
                            <Grid.Column width={16}>
                              <CombinationPaymentList
                                basePrice={combinationFormat.basePrice}
                              />
                            </Grid.Column>
                          )}
                        <Grid.Column width={16}>
                          <CombinationPricingOptionsDescription>
                            {combinationFormat.description}
                          </CombinationPricingOptionsDescription>
                        </Grid.Column>
                        {selectedCombinationFormatId === undefined && (
                          <Grid.Column width={16}>
                            <CombinationPricingOptionsExampleText>
                              Examples:
                            </CombinationPricingOptionsExampleText>
                            <div>
                              {getPlateFormatExampleCombinations(
                                combinationFormat.name,
                              ).map((exampleCombination, index) => {
                                return (
                                  <CombinationPricingOptionsImage key={index}>
                                    <span>{exampleCombination}</span>
                                  </CombinationPricingOptionsImage>
                                );
                              })}
                            </div>
                          </Grid.Column>
                        )}
                        {index < 2 && (
                          <Divider clearing className="price-options-divider" />
                        )}
                      </Grid.Row>
                    </Grid>
                  </CombinationPricingOptionContainer>
                )
              );
            })}
          </AccordionContent>
        </Accordion>
      </div>
    </CombinationPricingOptionsOuterWrapper>
  );
});
CombinationPricingOptions.displayName = 'CombinationPricingOptions';
export default CombinationPricingOptions;
